// extracted by mini-css-extract-plugin
export default {"priority-card":"PriorityCard_priority-card__3gBmx","icon-holder":"PriorityCard_icon-holder__p9Psx","card-body":"PriorityCard_card-body__FP4Xc"};